import { render, staticRenderFns } from "./CoverSection.vue?vue&type=template&id=41b58a52&scoped=true"
import script from "./CoverSection.vue?vue&type=script&lang=js"
export * from "./CoverSection.vue?vue&type=script&lang=js"
import style0 from "./CoverSection.vue?vue&type=style&index=0&id=41b58a52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b58a52",
  null
  
)

export default component.exports